// extracted by mini-css-extract-plugin
export default {"title":"Title_title__IUcTC","therapistname":"Title_therapistname__zceGi","logout":"Title_logout__DEXNr","settings":"Title_settings__aWZE0"};